import { Post } from "./common";

export default class DisputeTypeService {
  static all = async (token: string, data: any) =>
    await Post({ path: "dispute-types/all", token, body: data });
}
